/* eslint-disable max-len */
import { FunctionComponent, useState } from 'react';
import { CircularProgress, FormControl } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/client';

import TextInput from '../../components/input';
import useForm from '../../customHooks/useForm';
import AdminAuthWrapper from '../../components/AdminAuthWrapper';
import { ILoginAdminRequest, ILoginResponse } from '../../interfaces/admin';
import { ADMIN_LOGIN_MUTATION } from '../../graphql/admin_mutations';
import {
  useGlobalDispatch,
} from '../../contexts';
import useToast from '../../customHooks/useToast';
import { getRouteAdminCanGoBasedOnPermissions } from '../../utils/helpers';
import { encryptData } from '../../utils/encrypt';

import EmailIcon from '../../svgs/EmailIcon';
import PasswordShield from '../../svgs/PasswordShield';

import styles from './Login.module.scss';

export interface ILogin {
  label?: string;
}

const Login: FunctionComponent<ILogin> = () => {
  const { push } = useHistory();
  const { setToken, setUser } = useGlobalDispatch();
  const [loginMerchant] = useMutation<
    { adminLogin: ILoginResponse },
    any
  >(ADMIN_LOGIN_MUTATION);
  const [loading, setLoading] = useState(false);
  const Toast = useToast();
  // useEffect(() => {
  //   clearUser();
  // }, []);

  const {
    formValues,
    handleChange,
    resetForm,
  } = useForm(
    {
      email: '',
      password: '',
    },
  );

  const handleOnSubmit: (arg: any) => void = async (e) => {
    e.preventDefault();
    setLoading(true);
    const userLocation = localStorage.getItem('userLocation');

    try {
      const payload: ILoginAdminRequest = {
        email: formValues?.email,
        password: formValues?.password,
      };

      const reqPayload = await encryptData(JSON.stringify(payload));
      const resp = await loginMerchant({
        variables: {
          data: reqPayload,
        },
      });
      setLoading(false);
      if (resp && resp.data && resp.data.adminLogin) {
        resetForm({
          password: '',
          email: '',
        });
        if (parseInt(resp?.data?.adminLogin?.status, 10) !== 200) {
          // setError(resp.data.adminLogin.message);
          Toast.error(resp?.data?.adminLogin?.message);
          return;
        }
        if (resp.data.adminLogin.token) {
          setToken(resp.data.adminLogin.token);
          setUser(resp.data.adminLogin);
          Toast.success('Login successfully');
          if (userLocation) {
            push(userLocation);
          } else {
            const routeToPushTo = getRouteAdminCanGoBasedOnPermissions(resp.data.adminLogin.user?.role?.permissions);
            console.log('routeToPushTo', routeToPushTo);
            push(routeToPushTo);
          }
          return;
        }
        Toast.error('Something went wrong. Try again or contact Support');
      }
    } catch (e) {
      setLoading(false);
      if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
        const { message } = e.graphQLErrors[0];
        const newMessage = message || 'Invalid credentials';
        Toast.error(newMessage);
        // Toast.error(e.graphQLErrors[0].message)
      } else {
        console.log('e', e);
        Toast.error('Something went wrong. Try again or Contact Support');
      }
    }
  };

  return (
    <AdminAuthWrapper handleOnSubmit={handleOnSubmit} headText="Login to your account?👋">
      <div className={styles?.login}>
        <form className={styles?.login__form} action="" onSubmit={handleOnSubmit}>
          <FormControl className={styles?.login__content}>
            <TextInput
              customOnChange={handleChange}
              name="email"
              value={formValues.email}
              label="Email Address"
              width="100%"
              preIcon={<EmailIcon />}
              paddingLeft="44px"
            />
            <TextInput
              label="Password (8+ characters)"
              isSecure
              width="100%"
              customOnChange={handleChange}
              name="password"
              value={formValues.password}
              preIcon={<PasswordShield />}
              paddingLeft="44px"
              marginBottom="6px"
            />
            <div className={styles?.login__forget}>
              <Link className={styles?.login__link} to="./forgot-password"><span className={styles?.login__forgetText} onClick={() => {}}>Forgot Password?</span></Link>
            </div>
            <button className={`mb-2 ${!formValues.email || !formValues.password ? styles?.login__disabled : 'bg-primary'} text-white rounded ${styles?.login__btn}`} disabled={!formValues.email || !formValues.password}>
              {loading ? (
                <CircularProgress color="inherit" size={15} />
              ) : (
                'Sign in'
              )}

            </button>
          </FormControl>
        </form>
        {/* <div className={styles?.login__create}>
          Don’t have an account?
          {' '}
          <Link className={styles?.login__link} to="/register"><span className={styles?.login__createText}>Create one</span></Link>
        </div> */}
      </div>
    </AdminAuthWrapper>
  );
};

export default Login;
